import * as types from './mutation-types';

export default {
  [types.SET_MODAL_DISCOUNT_LIMIT](state) {
    state.modalDiscountLimit = !state.modalDiscountLimit;
  },
  [types.SET_ISS_EXIBILITY_COLLECTION](state, payload) {
    state.issExibilityCollection = payload;
  },
  [types.SET_TAX_REGIME_COLLECTION](state, payload) {
    state.taxRegimeCollection = payload;
  },
  [types.SET_NBS_COLLECTION](state, payload) {
    state.nbsCollection = payload;
  },
  [types.SET_CFOP_COLLECTION](state, payload) {
    state.cfopCollection = payload;
  },
  [types.SET_NFSE_NATURE_CODES_COLLECTION](state, payload) {
    state.nfseNatureCodesCollection = payload;
  },
  [types.SET_NFSE_NATURE_OF_OPERATION_COLLECTION](state, payload) {
    state.nfseNatureOfOperationCollection = payload;
  },
  [types.SET_NFSE_RESPONSIBLE_RETENTION_COLLECTION](state, payload) {
    state.responsibleRetentionCollection = payload;
  },
};
